import { Checkbox } from '@leverege/ui-elements';
import { GlobalState, Selection } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import S from './TargetGalleryItem.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  id: 'rsrc.toggleTarget',
  name: 'Toggle Target',
  matches: {
    client: ['rsrc.gallery.RsrcThumbnailRenderer'],
    use: ['actionBarLeft'],
    objectType: 'rsrc'
  },
  handles: context => {
    const item = Context.getTargetOfType(context, 'rsrc');
    return item != null;
  },
  customComponent: ({
    context
  }) => {
    const {
      clientProps: {
        targeted,
        targetKey
      }
    } = context;
    const item = Context.getTargetOfType(context, 'rsrc');
    const checked = Selection.isSelected(targeted, item.id);
    const toggleTarget = () => {
      if (checked) {
        return GlobalState.dispatch(Selection.remove(targetKey, item));
      }
      return GlobalState.dispatch(Selection.add(targetKey, item));
    };
    return /*#__PURE__*/_jsx(Checkbox, {
      variant: "targetRsrc",
      className: S.check,
      value: checked,
      onChange: toggleTarget
    });
  }
};